import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { isAPIApplicationException } from '../helpers';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private readonly _snackBar: MatSnackBar) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse) {
                    let errorMessage: string;
                    let statusCodeHandled = false;

                    if (error.error instanceof ErrorEvent) {
                        // client-side error
                        errorMessage = error.error.message;
                    } else {
                        // server-side error
                        statusCodeHandled = this.handleStatusCode(error);
                        errorMessage = error.error.title ?? error.message;
                        console.log('errorMessage: ' + errorMessage);
                    }

                    // Show a toast message of the error message.
                    // TODO: Do we want to configure this snackBar to look more error like?  Include error icon?
                    if (!statusCodeHandled) this.showErrorMessage(errorMessage);
                } else {
                    // TODO: Unanticipated error type.  Investigate how this error came to be and adjust this logic to anticipate it in the future.
                    if (!environment.production)
                        console.warn('Unanticipated error occurred:', error);
                }

                // We still want to re-throw the error.  We are going to do application-wide
                // side effects to errors from HTTP calls here.  This should NOT handle specific
                // side effects we want our individual components to have.  If a component needs
                // to do something when an error occurs, we allow the error to propogate back
                // to the original subscriber/caller so that additional side effects can take place
                // in their scope of concern.
                return throwError(error);
            })
        );
    }

    private showErrorMessage(errorMessage: string) {
        this._snackBar.open(errorMessage, undefined, {
            duration: 4000
        });
    }

    /**
     * If we want to handle different status codes slightly differently,
     * this is where we can have that behavior defined.
     */
    private handleStatusCode(error: HttpErrorResponse): boolean {
        let handled = false;
        // Don't do this in production.  This is for developers.  End-users don't need to see this.
        if (!environment.production) {
            switch (error.status) {
                case 400:
                    console.warn('BadRequest from API:', error);
                    break;
                case 401:
                    console.warn('Unauthorized from API:', error);
                    break;
                case 403:
                    console.warn('Forbidden from API:', error);
                    break;
                case 0:
                case -1:
                    handled = true;
                    this.showErrorMessage('Unable to contact server.');
                    break;
                case 500:
                    break;
                default:
                    console.warn('Unanticipated http status code:', error);
                    break;
            }
        }
        return handled;
    }
}
